import event from './gTag';

const handleGooglePlayLink = (userId: string | null, locale: string = 'en') => {
  event(
    'global_google_play_download_button_click',
    {
      event_category: 'interaction',
      device: 'Website',
    },
    { userId: userId, lang: locale }
  );

  window.open(
    'https://play.google.com/store/apps/details?id=com.spiritory.market&pli=1',
    '_blank'
  );
};
const handleAppleStoreLink = (userId: string | null, locale: string = 'en') => {
  event(
    'global_app_store_download_button_click',
    {
      event_category: 'interaction',
      device: 'Website',
    },
    { userId: userId, lang: locale }
  );

  window.open(
    'https://apps.apple.com/de/app/spiritory-whisky-wein-app/id6469595208',
    '_blank'
  );
};

export { handleGooglePlayLink, handleAppleStoreLink };
